import Storage from "../storage";

class IdentityAndAccessController {

    /**
     * Returns the current session status.
     *
     * @returns {Boolean} Returns true if there is a session active
     */
    static get sessionStatus () {
        const submittedTime = new Date().getTime();
        const existingTime = Storage.getData("defaultExpiry") * 1000 || submittedTime;
        const expectedTimeout = submittedTime - existingTime;
        const sessionKeyActive = this.sessionKey !== null;

        return 1 <= expectedTimeout && sessionKeyActive;
    }

    /**
     * Get the token
     *
     * @returns {string|null} The session key
     */
    static get sessionKey () {
        const storageKey = Storage.getData("sessionKey") || { key: null };

        return storageKey.key;
    }

    /**
     * Set the session
     *
     * @param sessionObject {Object} Session object
     */
    static set session (sessionObject) {
        const expectedTimeout = sessionObject.expiry_time * 1000;

        const accessToken = sessionObject.token;
        const expiresInSeconds = sessionObject.expiry_time;

        /** Add any information into the HTML5 storage **/
        Storage.setSessionKey(accessToken, expiresInSeconds);
        Storage.setData("defaultExpiry", sessionObject.expiry_time);
        Storage.setData("expiryTime", expectedTimeout);
    }

    /**
     * Destroy the session
     */
    static destroySession () {
        Storage.flush();
    }

    /**
     * Refire the session
     */
    static refireSession () {
        const expiresInSeconds = Storage.getData("defaultExpiry");

        if (null !== expiresInSeconds) {
            /** Time the user submitted their details. **/
            this.submittedTime = new Date().getTime();
            const expectedTimeout = this.submittedTime + (expiresInSeconds * 1000);

            Storage.setTTL("sessionKey", expiresInSeconds);
            Storage.setTTL("defaultExpiry", expiresInSeconds);
            Storage.setData("expiryTime", expectedTimeout);
        }
    }

}

export default IdentityAndAccessController;


// WEBPACK FOOTER //
// ./public/domain/controllers/identity-and-access-controller/index.js